//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    body: String,
    anchorName: String,
    isHiddenMobile: {
      type: Boolean,
      default: false
    }
  }
}
